import { RotateCcwIcon } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui'
import type { Transaction } from '@/modules/projects'
import { formatDate, numberToCurrency } from '@/utils'

export const RemovedSection = ({
  rows,
  onRestore,
}: {
  rows: Transaction[]
  onRestore: (row: Transaction) => void
}) => {
  const [open, setOpen] = useState(false)
  if (rows.length === 0) return null

  return (
    <div className="mt-2 border-t pt-2">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="cursor-pointer text-xs font-medium text-muted-foreground hover:text-foreground"
      >
        {open ? 'Hide' : 'Show'} removed ({rows.length})
      </button>
      {open && (
        <table className="mt-1 w-full text-xs">
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} className="border-t text-muted-foreground">
                <td className="py-1.5 pr-3 text-left tabular-nums">
                  {row.date ? formatDate(row.date) : '--'}
                </td>
                <td className="py-1.5 pr-3 text-left line-through">
                  {row.description}
                </td>
                <td className="py-1.5 pl-3 text-right tabular-nums line-through">
                  {numberToCurrency(row.amount)}
                </td>
                <td className="py-1.5 pl-2 text-right">
                  <Button
                    theme="ghost"
                    size="sm"
                    isIcon
                    className="cursor-pointer hover:text-foreground"
                    onClick={() => onRestore(row)}
                  >
                    <RotateCcwIcon className="size-3.5" />
                    <span className="sr-only">Restore row</span>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
